import { render, staticRenderFns } from "./ImgFetched.vue?vue&type=template&id=f5962c9c&scoped=true&"
import script from "./ImgFetched.vue?vue&type=script&lang=ts&"
export * from "./ImgFetched.vue?vue&type=script&lang=ts&"
import style0 from "./ImgFetched.vue?vue&type=style&index=0&id=f5962c9c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5962c9c",
  null
  
)

export default component.exports